import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import { Landing } from './pages/Landing';
import { Search } from './pages/Search';
import { Confirm } from './pages/Confirm';
import { AuthCode } from './pages/AuthCode';
import { Pay } from './pages/Pay';
import { Success } from './pages/Success';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminFilings } from './pages/AdminFilings';
import { AdminUpcoming } from './pages/AdminUpcoming';
import { AdminTasks } from './pages/AdminTasks';
import { AdminCustomers } from './pages/AdminCustomers';
import { AdminCustomerDetail } from './pages/AdminCustomerDetail';
import { AdminOrderDetail } from './pages/AdminOrderDetail';
import { AdminBlogList } from './pages/AdminBlogList';
import { AdminLeads } from './pages/AdminLeads';
import { AdminFileNow } from './pages/AdminFileNow';
import { AdminBlogEditor } from './pages/AdminBlogEditor';
import { AdminSettings } from './pages/AdminSettings';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Contact } from './pages/Contact';
import { Services } from './pages/Services';
import { ConfirmationStatement } from './pages/ConfirmationStatement';
import { Closure } from './pages/Closure';
import { NotFound } from './pages/NotFound';
import { ScrollToTop } from './components/ScrollToTop';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/search" element={<Search />} />
        <Route path="/confirm/:number" element={<Confirm />} />
        <Route path="/auth-code/:number" element={<AuthCode />} />
        <Route path="/pay/:orderId" element={<Pay />} />
        <Route path="/success/:orderId" element={<Success />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/filings" element={<AdminFilings />} />
        <Route path="/admin/upcoming" element={<AdminUpcoming />} />
        <Route path="/admin/tasks" element={<AdminTasks />} />
        <Route path="/admin/customers" element={<AdminCustomers />} />
        <Route path="/admin/customers/:email" element={<AdminCustomerDetail />} />
        <Route path="/admin/orders/:id" element={<AdminOrderDetail />} />
        <Route path="/admin/blog" element={<AdminBlogList />} />
        <Route path="/admin/blog/new" element={<AdminBlogEditor />} />
        <Route path="/admin/blog/:slug/edit" element={<AdminBlogEditor />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
        <Route path="/admin/file-now" element={<AdminFileNow />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/confirmation-statement" element={<ConfirmationStatement />} />
        <Route path="/closure" element={<Closure />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
